













































































import { AdgroupFormData } from '@tt4b/ttam-enums';
import { i18n } from '@tt4b/ttam-i18n';
import { computed, defineComponent, PropType, ref, toRefs, watch } from '@vue/composition-api';
import { isNil } from 'lodash-es';
const name = 'ttam-sidebar-copy-creative-dialog';

type AdgroupSidebarItem = {
  value: string;
  label: string;
  original: boolean;
  leftNum: number;
  disabled?: boolean;
  disabledHint?: string;
};

export default defineComponent({
  name,
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    creativeInfo: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: undefined,
    },
    creativeCountLeft: {
      type: Number,
      default: 0,
    },
    copyMaxNum: {
      type: Number,
      default: 20,
    },
    adgroupList: {
      type: Array as PropType<AdgroupSidebarItem[]>,
      default: () => [],
    },
    onlyToCurrentAdgroup: {
      type: Boolean,
      default: false,
    },
    /** 复制是否使用 name 前缀 */
    useNamePrefix: {
      type: Boolean,
      default: true,
    },
    copyNumLimitHint: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const { creativeCountLeft, copyNumLimitHint: copyCreativeNumLimitHint, disabled } = toRefs(props);
    const targetParentUuid = ref('');
    const copyMinNum = ref(0);
    const copyForm = ref();
    const inputNumber = ref();
    const formData = ref({
      copyNumber: 1, // copy  多少份
    });
    const copyCreativeNameArr = ref([]);

    const selectAdgroupInfo = computed(() => props.adgroupList.find(item => item.value === targetParentUuid.value));

    const creativeLeftNum = computed(() => {
      if (creativeCountLeft.value) {
        return creativeCountLeft.value;
      }
      // 如果不传可选数量，则默认 50
      return selectAdgroupInfo?.value?.leftNum !== undefined ? selectAdgroupInfo?.value?.leftNum : 50;
    });

    const disableCopyBtn = computed(() =>
      isNil(disabled.value)
        ? creativeLeftNum.value <= 0 || creativeLeftNum.value - formData.value.copyNumber < 0
        : disabled.value,
    );

    const copyNumLimitAlertVisible = computed(() => creativeLeftNum.value - formData.value.copyNumber <= 0);

    const currentCopyNumLimitHint = computed(
      () =>
        copyCreativeNumLimitHint.value ||
        i18n.t('module_creative_copy_dialog_num_hint_new', {
          module_creative_copy_dialog_num_hint_ad_max: i18n.t('module_creative_copy_dialog_num_hint_ad_max', {
            num: props.copyMaxNum,
          }),
          module_creative_copy_dialog_num_hint_copy_max: i18n.t('module_creative_copy_dialog_num_hint_copy_max', {
            num: creativeLeftNum.value > 0 ? creativeLeftNum.value : 0,
          }),
        }),
    );

    const checkIsNotCurAdgroup = (item: AdgroupSidebarItem) => {
      if (!props.onlyToCurrentAdgroup) {
        return false;
      }

      return !item.original;
    };

    const resetCopyForm = () => {
      formData.value.copyNumber = 1;
      targetParentUuid.value = '';
      copyCreativeNameArr.value = [];
    };

    const handleCopyCreativeNameArr = num => {
      if (num > copyCreativeNameArr.value.length) {
        for (let i = copyCreativeNameArr.value.length; i < num; i++) {
          let newName = props.useNamePrefix
            ? i18n.t('flexible_copy_title_prefix', {
                Number: i + 1,
                Name: props.creativeInfo.name,
              })
            : props.creativeInfo.name;

          copyCreativeNameArr.value.push(newName);
        }
      } else if (num < copyCreativeNameArr.value.length) {
        for (let i = copyCreativeNameArr.value.length; i > num; i--) {
          copyCreativeNameArr.value.pop();
        }
      }
    };
    const handleCopyNumberChange = num => {
      if (num <= props.copyMaxNum) {
        handleCopyCreativeNameArr(num);
      }
      emit('copy-number-change', num);
    };

    const handleOpen = () => {
      targetParentUuid.value = props.creativeInfo.adgroupUuid;
      handleCopyCreativeNameArr(formData.value?.copyNumber || 1);
      emit('open');
    };
    const handleClose = () => {
      resetCopyForm();
      emit('close');
    };
    const handleCopy = () => {
      emit('click-confirm');
      emit('copy', copyCreativeNameArr.value, targetParentUuid.value);
    };
    const handleCancel = () => {
      emit('click-cancel');
      handleClose();
    };

    watch(
      copyNumLimitAlertVisible,
      (val, preVal) => {
        if (val !== preVal) {
          emit('copy-numlimit-alert-visible-change', val);
        }
      },
      { immediate: true },
    );

    watch(creativeLeftNum, leftNum => {
      if (leftNum <= 0) {
        formData.value.copyNumber = 0;
      } else {
        formData.value.copyNumber = 1;
      }
    });

    return {
      name,
      targetParentUuid,
      creativeLeftNum,
      selectAdgroupInfo,

      copyMinNum,
      inputNumber,
      formData,
      copyNumLimitAlertVisible,
      copyForm,
      currentCopyNumLimitHint,
      copyCreativeNameArr,
      disableCopyBtn,
      handleClose,
      handleCopy,
      handleOpen,
      handleCancel,
      handleCopyNumberChange,
      checkIsNotCurAdgroup,
    };
  },
});
